export class CampaignPayload {
  private name: string = '';
  private channel: string = '';
  private subject: string = '';
  private templateId: number = 0;
  private messageTemplate: string = '';
  private status: string = 'draft';
  private createdBy: number = 0;
  private csvattachments: any[] = [];

  setName(name: string) { this.name = name; }
  setChannel(channel: string) { this.channel = channel; }
  setSubject(subject: string) { this.subject = subject; }
  setTemplateId(id: number) { this.templateId = id; }
  setMessageTemplate(template: string) { this.messageTemplate = template; }
  setStatus(status: string) { this.status = status; }
  setCreatedBy(id: number) { this.createdBy = id; }
  setCsvAttachments(attachments: any[]) { this.csvattachments = attachments; }

  // This method is required by your Service's data parameter
  toString(): string {
    return JSON.stringify({
      name: this.name,
      channel: this.channel,
      subject: this.subject,
      templateId: this.templateId,
      messageTemplate: this.messageTemplate,
      status: this.status,
      createdBy: this.createdBy,
      csvattachments: this.csvattachments
    });
  }
}